"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const navigation_1 = __importDefault(require("@App/navigation"));
const TipaltiIFrame = (props) => {
    const { tipaltiIFrame, setPreloaderIsOpen } = props;
    const [iframeHeight, setIframeHeight] = (0, react_1.useState)(0);
    const tipaltiHandler = (evt) => {
        if (evt.data && evt.data.TipaltiIframeInfo && evt.data.TipaltiIframeInfo.height) {
            setIframeHeight(evt.data.TipaltiIframeInfo.height);
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('message', tipaltiHandler, false);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, tipaltiIFrame.url ? (react_1.default.createElement("iframe", { className: 'tipalti-iframe-mlc', title: 'Tipalti Iframe', height: iframeHeight, frameBorder: 0, allowFullScreen: true, src: tipaltiIFrame.url, onLoad: () => setPreloaderIsOpen(false) })) : tipaltiIFrame.message ? (react_1.default.createElement("p", null,
        "To reduce potential for fraud, once you have reached your monthly earnings threshold, you will need to reach out to our support team to make any changes to your banking information. You can do so\u00A0",
        react_1.default.createElement("a", { className: 'link', href: navigation_1.default.contactUs.root() }, "here."))) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.default = TipaltiIFrame;
